import { EnglishArabicDTO } from "bnsights-control-library"
export class WFCreationModel
{
      Id:number
      IDEncrypted:string
      SysName :string
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      Description :EnglishArabicDTO=new EnglishArabicDTO();
      CurrentVersionID :number
      WorkflowVersionIDEncrypted:string
      IsActive:boolean
      IsPublished:boolean
}
     